import { type CoreLayoutProps, Layout } from 'react-admin'
import React from 'react'

export const LayoutWithoutTitle: React.FC<CoreLayoutProps> = (props) => (
  <Layout {...props} appBar={() => null} sidebar={() => null} menu={() => null} sx={{ '& .RaLayout-appFrame': { marginTop: 0 } }} />
)
